import * as types from './constants';

export const loading = (isLoading) => {
    return {
        type: types.SET_LOADING,
        payload: isLoading
    };
};
